<template> 
  <div> 
    <div class="ms-4">
        <div class="page-title flex-row me-3"> 
            <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('general_account_report') }}
            </h1>  
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                    </a>
                </li> 
                <li class="breadcrumb-item text-primary">{{ $t('reports') }}</li>  
                <li class="breadcrumb-item text-primary">{{ $t('account_report') }}</li>    
                <li class="breadcrumb-item text-gray-600">{{ $t('general_account_report') }}
                    <HelpPageIcon v-if="this.iconView == true" :menuSelection="this.menuSelection"></HelpPageIcon>
                </li> 
            </ul> 
        </div>  
    </div>
    <div class="content flex-row-fluid mt-4" id="kt_content">
        <div class="card">
            <div class="row fv-row border-0 pt-6 px-9">
                <div class="col-lg-9">
                    <div class="fv-row mb-4 row"> 
                        <div class="col-lg-3">
                            <label class="fs-6 form-label mt-3">
                                <span>{{ $t('account_type') }}</span>
                            </label>
                            <Select2 v-model="this.form.account_type" :options="this.accountTypeList" :settings="{ width: '100%' }"/>  
                        </div>
                        <div class="col-lg-3">
                            <label class="fs-6 form-label mt-3">
                                <span>{{ $t('currency') }}</span>
                            </label>
                            <Select2 v-model="this.form.currency" :options="this.currencyList" :settings="{ width: '100%' }" @select="onChangeCurrency()"/>  
                        </div>
                        <div class="col-lg-3">
                            <label class="fs-6 fw-bold form-label mt-3">
                                <span>{{ $t('empty_accounts') }}</span>
                            </label>
                            <Select2 v-model="form.with_no_balance" :options="viewEmptyList" :settings="{ width: '100%' }"/> 
                        </div> 
                        <div class="col-lg-3">
                            <label class="fw-bold form-label mt-3">
                                <span>{{ $t('report_type') }}</span>
                            </label> 
                            <Select2 v-model="form.report_type" :options="reportTypes"  :settings="{ width: '100%' }"/> 
                        </div>
                    </div>
                    <div class="fv-row mb-4 row">
                        <div class="col-lg-3" v-if="form.report_type == '2'">
                            <label class="fs-6 form-label mt-3">
                                <span>{{ $t('start_date') }}</span>
                            </label>
                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.start_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                        </div>  
                        <div class="col-lg-3" v-if="form.report_type == '2'">
                            <label class="fs-6 form-label mt-3">
                                <span>{{ $t('end_date') }}</span>
                            </label>
                            <Datepicker :locale="$datepickerLocale()"  textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="form.end_date" inputClassName="form-control" format="dd.MM.yyyy" autoApply :clearable="false" weekNumbers :monthChangeOnScroll="'inverse'" :enableTimePicker="false"></Datepicker>  
                        </div>
                    </div>
                </div>
                <div class="col-lg-3">
                    <div class="d-flex justify-content-end" data-kt-customer-table-toolbar="base" v-if="this.$isCredentialActive(65,'R')">
                        <Popper hover placement="top">
                            <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                <i class="bi bi-eraser-fill fs-4"> </i>
                            </button>
                            <template #content>
                                <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                            </template>
                        </Popper> 
                        <button type="button" class="btn btn-light-primary border border-primary" @click="getListData()" data-kt-indicator="on">
                            <span class="svg-icon svg-icon-muted"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path opacity="0.3" d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z" fill="currentColor"/>
                                <path d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z" fill="currentColor"/>
                                </svg>
                            </span>
                            <span v-if="!this.isListProgressing"> {{ $t('list_transactions') }} </span> 
                            <span class="indicator-progress" v-if="this.isListProgressing">
                                {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span> 
                        </button> 
                    </div>
                    <div class="d-flex justify-content-end align-items-center d-none" data-kt-customer-table-toolbar="selected">
                        <div class="fw-bolder me-5">
                        <span class="me-2" data-kt-customer-table-select="selected_count"></span>{{ $t('selected') }}</div>
                        <button type="button" class="btn btn-danger" data-kt-customer-table-select="delete_selected">{{ $t('delete_selected') }}</button>
                    </div>
                </div>
            </div>
            <div class="card-body pt-3">
                <div class="separator my-3 mt-0 border-gray-300" style="margin-top: -10px !important;"></div>
                <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div class="table-responsive min-h-300px">

                        <ListOptions :name="this.$options.name" ref="listOptionComponent"></ListOptions>
                         <DxDataGrid id="gridContainer"
                                :key="$i18n.locale"
                                :show-borders="true"
                                key-expr="id"
                                :data-source="lists"
                                :allow-column-reordering="true" 
                                :allow-column-resizing="true"
                                :column-auto-width="true"
                                :customize-columns="onCustomizeColumn"
                                :row-alternatin-enabled="true"
                                :hover-state-enabled="true" 
                                :show-row-lines="true" 
                                :ref="'dataGrid'"
                                @exporting="this.$onExporting($event , 'General-Account-Report-List')">   
                                <DxFilterRow :visible="true"/>
                                <DxHeaderFilter :visible="true"/>
                                <DxGroupPanel :visible="true"/>      
                                <DxExport :enabled="this.$getUser().is_allow_export" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                <DxPaging :page-size="100"/>
                                <DxPager :visible="false" :allowed-page-sizes="pageSizes" :show-page-size-selector="showPageSizeSelector" :show-info="true" :show-navigation-buttons="true"/> 
                                <DxSearchPanel :visible="true"/> 
                                <DxScrolling
                                    mode="virtual"
                                    row-rendering-mode="virtual"
                                />
                                <DxColumn data-field="detail" caption="..." cell-template="detail-cell-template" alignment="center" :allow-exporting="false" :width="45"/> 
                                <DxColumn data-field="account_code" :caption="$t('account_code')" header-cell-template="account-code-header"/>
                                <DxColumn data-field="name" :caption="$t('account_name')" header-cell-template="stock-type-name-header"/>
                                <DxColumn data-field="account_type_name" :caption="$t('account_type')" header-cell-template="account-type-header"/>
                                <DxColumn data-field="turnover_balance" :sorting-method="this.$numericSort" :caption="$t('turnover_amount')"  alignment="right" :visible="this.usedCriterias.currency !== '-1'"/>
                                <DxColumn data-field="turnover_balance_local" :sorting-method="this.$numericSort" :caption="$t('turnover_local_amount')"  alignment="right" header-cell-template="turnover-local-amount-header"/>
                                <DxColumn data-field="debit" :caption="$t('total_debit')" :sorting-method="this.$numericSort"  alignment="right" header-cell-template="total-debit-header" :visible="this.usedCriterias.currency !== '-1'"/>
                                <DxColumn data-field="debit_local" :caption="$t('total_local_debit')" :sorting-method="this.$numericSort"  alignment="right" header-cell-template="total-local-debit-header"/>
                                <DxColumn data-field="credit" :caption="$t('total_credit')" :sorting-method="this.$numericSort"  alignment="right" header-cell-template="total-credit-header" :visible="this.usedCriterias.currency !== '-1'"/>
                                <DxColumn data-field="credit_local" :caption="$t('total_local_credit')" :sorting-method="this.$numericSort"  alignment="right" header-cell-template="total-local-credit-header"/>
                                <DxColumn cssClass="bg-light-indigo" data-field="balance" :caption="$t('total_balance')" :sorting-method="this.$numericSort"  alignment="right" header-cell-template="total-balance-header" :visible="this.usedCriterias.currency !== '-1'"/>
                                <DxColumn data-field="balance_local" :caption="$t('total_local_balance')" :sorting-method="this.$numericSort"  alignment="right" header-cell-template="total-local-balance-header"/>
                                <DxColumn data-field="last_transaction_date" :caption="$t('last_transaction_date')" alignment="right" data-type="date" format="dd.MM.yyyy" header-cell-template="last-transaction-date-header"/> 

                                <template #detail-cell-template="{ data }">
                                    <a href="#" class="btn btn-sm btn-icon text-hover-primary w-20px h-20px" 
                                        @click="onOpenAccountReport(data.data)" data-bs-toggle="modal" data-bs-target="#kt_modal_general_account_report" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                        <i class="fa fa-eye text-gray-600 fs-3"></i>
                                    </a>
                                </template>
                                <template #headerTemplate="{ data: data }">
                                    <div v-html="setColumnTemplate(data)"></div> 
                                </template>
                                <template #headerLocalTemplate="{ data: data }">
                                    <div v-html="setColumnTemplateForLocal(data)"></div> 
                                </template>

                                <template #account-code-header>
                                    <div>{{ $t('account_code') }}</div>
                                </template>
                                <template #stock-type-name-header>
                                    <div>{{ $t('account_name') }}</div>
                                </template>
                                <template #account-type-header>
                                    <div>{{ $t('account_type') }}</div>
                                </template>
                                <template #turnover-amount-header>
                                    <div>{{ $t('turnover_amount') }}</div>
                                </template>
                                <template #turnover-local-amount-header>
                                    <div>{{ $t('turnover_local_amount') }}</div>
                                </template>
                                <template #total-debit-header>
                                    <div>{{ $t('total_debit') }}</div>
                                </template>
                                <template #total-local-debit-header>
                                    <div>{{ $t('total_local_debit') }}</div>
                                </template>
                                <template #total-credit-header>
                                    <div>{{ $t('total_credit') }}</div>
                                </template>
                                <template #total-local-credit-header>
                                    <div>{{ $t('total_local_credit') }}</div>
                                </template>
                                <template #total-balance-header>
                                    <div>{{ $t('total_balance') }}</div>
                                </template>
                                <template #total-local-balance-header>
                                    <div>{{ $t('total_local_balance') }}</div>
                                </template>
                                <template #last-transaction-date-header>
                                    <div>{{ $t('last_transaction_date') }}</div>
                                </template>

                               
                                
                                <DxSummary :calculate-custom-summary="setSummaries">
                                    <DxTotalItem column="id" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="account_code"/>
                                    <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="turnover_balance_local"
                                        summary-type="custom"
                                        show-in-column="turnover_balance_local"
                                        display-format="{0}"
                                    /> 
                                     <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="balance_local"
                                        summary-type="custom"
                                        show-in-column="balance_local"
                                        display-format="{0}"
                                    /> 
                                     <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="debit_local"
                                        summary-type="custom"
                                        show-in-column="debit_local"
                                        display-format="{0}"
                                    /> 
                                     <DxGroupItem
                                        :show-in-group-footer="true"
                                        name="credit_local"
                                        summary-type="custom"
                                        show-in-column="credit_local"
                                        display-format="{0}"
                                    /> 
                                    <DxTotalItem
                                        name="turnover_balance_local"
                                        summary-type="custom"
                                        show-in-column="turnover_balance_local"
                                    />
                                    <DxTotalItem
                                        name="balance_local"
                                        summary-type="custom"
                                        show-in-column="balance_local"
                                    /> 
                                    <DxTotalItem
                                        name="debit_local"
                                        summary-type="custom"
                                        show-in-column="debit_local"
                                    /> 
                                    <DxTotalItem
                                        name="credit_local"
                                        summary-type="custom"
                                        show-in-column="credit_local"
                                    /> 
                                </DxSummary>

                                <DxStateStoring
                                        :enabled="true"
                                        type="custom"
                                        :storage-key="this.storageKey"
                                        :ref="dataGrid" 
                                        :saving-timeout="1000"
                                        :custom-load="LoadDXState"
                                    />
                        </DxDataGrid>     
                    </div>
                </div> 
            </div>
        </div> 
    </div>
    <div class="modal fade" id="kt_modal_general_account_report" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <AccountReports ref="AccountReports" :account-name="accountReport.name" :account-id="accountReport.id" :account-type="3"/>
    </div>
  </div>  
</template>
<script>
import axios from 'axios' 

import moment from 'moment'; 
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem, DxGroupItem, DxStateStoring, DxScrolling } from 'devextreme-vue/data-grid';
 
export default {
  name: "GeneralAccountReport",
  components:{
    DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSummary, DxTotalItem, DxGroupItem, DxStateStoring, DxScrolling
  }, 
  data() {
    return {
        storageKey: 'dx_' + this.$options.name,
        pageSize: 100,
        pageSizeDetailList: 10,
        page: 1, 
        page_size: 20,
        lists: [],
        form:  {
            start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
            end_date: moment(),  
            account_type: 0,
            currency: '-1', 
            report_type: 1,
            with_no_balance: 0
        },
        isListProgressing: false,
        isFilterOpen: false,
        reportTypes: [{ id: '1', text: this.$t('general')}, { id: '2', text: this.$t('date_range')}],
        viewEmptyList: [ { id: 0, text: this.$t('no_view')}, { id: 1, text: this.$t('view_all')}, { id: 2, text: this.$t('view_positive_accounts') },{ id: 3, text: this.$t('view_negative_accounts')}, { id: 4, text: this.$t('view_empty_accounts')} ],
        accountTypeList: [],
        currencyList: [],
        summary: {},
        usedCriterias: {},
        localCurrency: this.$getUser().currency_code,
        menuSelection: '/GeneralAccountReportHelppage',
        iconView : false,
        accountReport: {
            id: null,
            name: null
        }
    };
  },
  computed: {
   setColumnTemplate(){
        return (value)=>{
            const captionValue = value.column.caption.replace(this.$t('local'), ' ');
            return this.localCurrency == null ? this.$t(captionValue) : this.localCurrency + '<br>' + this.$t(captionValue);          
        }
   },
   setColumnTemplateForLocal(){
        return (value)=>{
            const captionValue = value.column.caption.replace(this.$t('local'), ' ');
            return this.localCurrency == null ? this.$t(captionValue) : this.localCurrency + '<br>' + this.$t(captionValue);          
        }
   },
   previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    showPageSizeSelector() {
        return this.lists.length > this.pageSize;
    },
    pageSizes() {
        let arr = [];
        let x = 1;
        let loop = (this.lists.length / this.pageSize);
        for (let i = 1; i <= loop && i <= 5; i++) {
            arr.push(this.pageSize * x);
            x++;
        }
        if(loop > 5) arr.push(1000);
        if(loop > 1) arr.push('all');
        return arr;
    }
  },
  methods: {
    getData(){
        this.$Progress.start();
        this.accountTypeList = [];
        this.usedCriterias = {};
        this.currencyList = [];  

        const parameters = {
            session_id: this.$getUser().session_id,
            tip: 16, //Account Types
            list_name: ["currency"]
        };  
        const requestOne =  axios.post('/api/Helper/GetConst', parameters, {'Content-Type': 'application/json'});
        const requestTwo =  axios.post('/api/Helper/GeneralLists', parameters, {'Content-Type': 'application/json'}); 
        axios.all([requestOne, requestTwo]).then(axios.spread((...responses) => {
                this.accountTypeList = responses[0].data;
                this.accountTypeList = this.accountTypeList.filter(account => !( account.deger === "7")); //Stock dışındakiler geliyor
                this.accountTypeList.unshift({ id: 0, text: this.$t('all')});
                this.currencyList = responses[1].data.currency;
                this.currencyList.unshift({ id: '-1', text: this.$t('all')});
                this.form.currency = '-1'; 
                this.localCurrency = this.$getUser().currency_code;
                this.$Progress.finish(); 
            })
        )
        .catch(errors => { 
            console.error(errors);
            this.$Progress.finish(); 
        }); 
    },
    getListData() {
        this.$Progress.start();
        this.usedCriterias = {};
        this.isListProgressing = true;
        this.form.start_date = (this.form.start_date == null || this.form.start_date == '') ? moment() : this.form.start_date;
        this.form.end_date = ( this.form.end_date == null || this.form.end_date == '') ? moment () : this.form.end_date; 
        
        const params = {
            session_id: this.$getUser().session_id,
            start_date: moment(this.form.start_date).format('YYYY-MM-DD[T]HH:mm:ss'),
            end_date: moment(this.form.end_date).format('YYYY-MM-DD[T]HH:mm:ss'),
            report_type: this.form.report_type,
            account_type: this.form.account_type,
            currency: this.form.currency,
            with_no_balance: this.form.with_no_balance
        };
        params.currency = this.form.currency == '-1' ? null : this.form.currency;
        axios.post('/api/Transaction/GetGeneralTransactionList', params, {'Content-Type': 'application/json'})
        .then((response) => {
            this.lists = response.data.transactions;  
            this.summary = response.data.summary;
            this.usedCriterias = this.form;
            this.$Progress.finish();
            setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        })
        .catch((error) => {
            console.error(error); 
            this.$Progress.finish();
            setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        });  
    },
    setCriteriasToDefault() {   
        this.form = {
            start_date: moment().subtract((parseInt(this.$getUser().list_date_range)), 'days'),
            end_date: moment(),  
            account_type: 0,
            currency: '-1', 
            report_type: 1,
            with_no_balance: 0
        };
        this.lists = [];
    },
    setSummaries(options){  
        const optionNames = ["turnover_balance_local", "balance_local", "debit_local","credit_local"]; 
        optionNames.forEach(item => {
            if(options.name == item){
                if(options.summaryProcess === 'start'){ options.totalValue = 0; }
                else if(options.summaryProcess === 'calculate'){
                    var itemValue = parseFloat(options.value[item].replaceAll(',', ''));
                    (options.totalValue += itemValue);
                }
                else if(options.summaryProcess === 'finalize'){ 
                    options.totalValue = Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(options.totalValue);
                }
            }
        });
    },
    onCustomizeColumn(e){
        if(e){
            if(!e._isUpdated){
                if(e.length > 0){ 
                    e._isUpdated = true;
                }
                e.forEach((column) => {
                    if(column.dataField == 'turnover_balance_local'){ 
                        column.caption = this.$t('turnover_local_amount');
                        column.headerCellTemplate = 'headerLocalTemplate';
                    }
                    if(column.dataField == 'debit_local'){ 
                        column.caption = this.$t('total_local_debit');
                        column.headerCellTemplate = 'headerLocalTemplate';
                    }
                    if(column.dataField == 'credit_local'){ 
                        column.caption = this.$t('total_local_credit');
                        column.headerCellTemplate = 'headerLocalTemplate';
                    }
                    if(column.dataField == 'balance_local'){ 
                        column.caption = this.$t('total_local_balance');
                        column.headerCellTemplate = 'headerLocalTemplate';
                    }
                });  
            } 
        } 
    },
    onChangeCurrency(){
        this.lists = [];
    },
    /** DX STATE OPERATIONS **/  
    LoadDXState() {
        return JSON.parse(sessionStorage.getItem(this.storageKey));
    }, 
    async helpPageViewIcon()
    {
        const queryparameter = {
            session_id : this.$getUser().session_id,
            menu_selection : '/GeneralAccountReportHelppage'
        };
        axios.post('api/HelpPage/HelpPagesContent', queryparameter, {'Content-Type': 'application/json'})
        .then((response) => { 
            if(!response.data.error){ 
                this.iconView = response.data;
            }
        })
    }, 
    onOpenAccountReport(item){
        let accountInfo = {
            id: item.id, 
            name: item.name
        };
        this.$refs.AccountReports.getData(accountInfo);
        this.$refs.AccountReports.setModalCriteriasToDefault();
    },
  },
  created() {
    this.helpPageViewIcon();
    this.$removeSessionStorage('record_id');
    this.lists = [];
    this.getData();
  }
}; 
</script>